import { PixiGameHost } from '@vpgc/render-pixi';
import {
  temptrashContract,
  createInitialState,
  NO_INPUT,
  type GameState,
  type Input,
  type SaveJson,
  type ViewModel,
} from '../index.js';
import { InputBridge } from './input-bridge.js';
import { TemptrashRenderer } from './renderer.js';
import './styles.css';

async function main(): Promise<void> {
  const root = document.querySelector<HTMLElement>('#game-root');
  if (root === null) throw new Error('Missing #game-root');

  const bridge = new InputBridge(root);
  const host = await PixiGameHost.create<GameState, Input, ViewModel, SaveJson>({
    container: root,
    contract: temptrashContract,
    renderer: new TemptrashRenderer(),
    initialState: createInitialState(seedFromUrl()),
    noOpInput: NO_INPUT,
    sampleInput: () => bridge.sample(),
    getTick: (state) => state.tick,
    pixelArt: true,
  });
  const unsubscribe = host.subscribe((view) => bridge.setView(view));

  window.addEventListener('pagehide', () => {
    unsubscribe();
    bridge.destroy();
    void host.destroy();
  }, { once: true });

  Object.assign(window, {
    __temptrashDebug: {
      snapshot: () => host.snapshot(),
      view: () => host.getViewModel(),
    },
  });
}

function seedFromUrl(): number {
  const params = new URLSearchParams(window.location.search);
  const parsed = Number(params.get('seed'));
  if (Number.isFinite(parsed)) return parsed | 0;
  return 1;
}

main().catch((error) => {
  console.error(error);
});
